import styles from './form.module.css';

export const Form = ({ children, className = '', ...rest }) => {
    return (
        <form className={`${styles.form} ${className}`} {...rest}>
            {children}
        </form>
    );
};
